export default __webpack_public_path__ + "static/media/instagram-square-brands.b47920a8.svg";